import HTTP from "./HTTP";

export default {
  authenticate(creds) {
    return HTTP.withAccept.post("/authentication", creds);
  },
  checkToken() {
    return HTTP.withAccept.get("/token_check");
  }
};



// WEBPACK FOOTER //
// ./src/API/authentication.js